//@flow
import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { identity } from "ramda";

import { Translate } from "@quantum/i18n";

import { type ModoApp, MODO_APP_SERIES } from "../../../model";

import {
  type ActionCreator,
  deveDesabilitarExclusaoMultiplasDeMedidas,
  desmarcarTodasMedidasSelecionada,
  excluirMedidasMarcadas,
  getModoApp,
  getNomeArquivoEmCache,
  isTodasMedidasSelecionadasMarcadas,
  marcarTodasMedidasSelecionada,
} from "../../../state";

import SelecaoDataBase from "../../edicaoMedidas/configuracoes/periodos/SelecaoDataBase";
import SelecaoFechamentoDeMes from "../../edicaoMedidas/configuracoes/fechamentoDeMes/SelecaoFechamentoDeMes";

import {
  HeaderSubSecao,
  HeaderSubSecaoGrupo,
  HeaderSubSecaoTitulo,
} from "../../comum/HeaderSubSecao";

import { WithTooltip } from "../tooltip";

import IconeExcluirMedida from "../../../assets/excluir_medida.gif";

import "./medidas-selecionadas-header.css";

type Props = {
  excluirMedidasMarcadas: ActionCreator,
  exclusaoDesabilitada: boolean,
  quantidadeMedidasSelecionadas: number,
  modo: ModoApp,
  nomeArquivoEmCache: ?string,
  alternarTodasMedidas: ActionCreator,
  todasMedidasMarcadas: boolean,
  semFechamentoDeMes: ?boolean,
  semDataBase: ?boolean,
};

function MedidasSelecionadasHeader({
  alternarTodasMedidas,
  exclusaoDesabilitada,
  excluirMedidasMarcadas,
  quantidadeMedidasSelecionadas,
  modo,
  nomeArquivoEmCache,
  todasMedidasMarcadas,
  semFechamentoDeMes = false,
  semDataBase = false,
}: Props) {
  const isModoSeries = modo === MODO_APP_SERIES;

  return (
    <HeaderSubSecao
      className={classNames("MedidasSelecionadasHeader", {
        "MedidasSelecionadasHeader--Series": isModoSeries,
      })}
    >
      <HeaderSubSecaoGrupo>
        <div className="MedidasSelecionadasHeader__checkbox">
          <input
            type="checkbox"
            checked={todasMedidasMarcadas}
            onChange={alternarTodasMedidas}
            disabled={quantidadeMedidasSelecionadas === 0}
          />
        </div>

        <HeaderSubSecaoTitulo>
          <Translate>todasMaiusculas.medidasSelecionadas</Translate>
          <span className="MedidasSelecionadasHeader__quantidade">
            ({quantidadeMedidasSelecionadas})
          </span>
        </HeaderSubSecaoTitulo>

        <div className="MedidasSelecionadasHeader__medidas-salvas">
          {nomeArquivoEmCache}
        </div>
      </HeaderSubSecaoGrupo>

      <HeaderSubSecaoGrupo>
        {semFechamentoDeMes || (
          <span className="MedidasSelecionadasHeader__fechamento-mes">
            <SelecaoFechamentoDeMes />
          </span>
        )}

        {semDataBase || (
          <div className="MedidasSelecionadasHeader__data-base">
            <span className="MedidasSelecionadasHeader__label-data-base">
              <Translate>maiusculas.dataBase</Translate>
            </span>
            <SelecaoDataBase
              portal={false}
              inputProps={{
                className: "MedidasSelecionadasHeader__input-data-base",
              }}
            />
          </div>
        )}

        {quantidadeMedidasSelecionadas > 0 && (
          <div className="MedidasSelecionadasHeader__excluir">
            <WithTooltip
              overlayClassName="MedidasSelecionadasHeader__excluir-tooltip"
              enabled={exclusaoDesabilitada}
              trigger="hover"
              placement="topRight"
              overlay={
                <span>
                  <Translate>
                    configuracaoRelatorio.algumaMedidaNaoPodeSerExcluida
                  </Translate>
                </span>
              }
            >
              <img
                className={classNames(
                  "MedidaSelecionadasHeader__excluir-icone",
                  exclusaoDesabilitada &&
                    "MedidaSelecionadasHeader__excluir-icone--desabilitado"
                )}
                src={IconeExcluirMedida}
                alt="Excluir Medidas"
                onClick={
                  exclusaoDesabilitada ? identity : excluirMedidasMarcadas
                }
              />
            </WithTooltip>
          </div>
        )}
      </HeaderSubSecaoGrupo>
    </HeaderSubSecao>
  );
}

export default connect(
  state => ({
    todasMedidasMarcadas: isTodasMedidasSelecionadasMarcadas(state),
    nomeArquivoEmCache: getNomeArquivoEmCache(state),
    exclusaoDesabilitada: deveDesabilitarExclusaoMultiplasDeMedidas(state),
    modo: getModoApp(state),
  }),
  {
    excluirMedidasMarcadas,
    marcarTodas: marcarTodasMedidasSelecionada,
    desmarcarTodas: desmarcarTodasMedidasSelecionada,
  },
  (
    stateProps,
    { marcarTodas, desmarcarTodas, ...dispatchProps },
    ownProps
  ) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    alternarTodasMedidas: stateProps.todasMedidasMarcadas
      ? desmarcarTodas
      : marcarTodas,
  })
)(MedidasSelecionadasHeader);
